import { createContext } from 'react';

/**
 * 标记当前渲染树是否位于管理中心外壳（AdminLayout）内。
 *
 * 为什么需要它：
 * AdminRoutes 会去掉 /admin 前缀后再匹配路由，页面内 useLocation() 拿到的是
 * 去掉前缀后的路径（如 /profile），仅靠路径前缀无法判断"是否在管理中心内"，
 * 会导致页面自带的页头 / 页脚重复渲染。
 */
const AdminShellContext = createContext(false);

export default AdminShellContext;
